import React, { useState } from 'react';
import AppRoutes from './routes';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import type {} from '@mui/lab/themeAugmentation';
import { createTheme, ThemeProvider } from '@mui/material';
import SessionContext from './Context/SessionContext';
import { ISession } from './interfaces/IContext';
import { inicializa_session } from './utils/format';

const theme = createTheme({
  components: {
    MuiButton: {
      defaultProps: {
        variant: 'contained'
      }
    }
  }
});

function App() {
  const [session, setSession] = useState<ISession>(inicializa_session());

  return (
      <ThemeProvider theme={theme}>
        <SessionContext.Provider value={{ session, setSession }}>
          <AppRoutes />
        </SessionContext.Provider>
      </ThemeProvider>
  );
}

export default App;
